import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from 'lodash';
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {PlanningRequestsService} from "../../services/planning-requests.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class PlanningProjectsTableViewCtrl implements IController {

  branchIds?: string[];

  public filterConfig: any;

  private loadLimit: number;
  private readonly projectsRef: any;
  private infiniteScroll: any;


  /* @ngInject */
  constructor(private confirmDialogService: ConfirmDialogService, private planningAlertsService: PlanningAlertsService, private $log, private $infiniteScroll,
              private bringozLoaderService: BringozLoaderService, private planningRequestsService: PlanningRequestsService, private $planningProjects,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $scope: IScope) {

    this.projectsRef = $planningProjects();
  }

  $onInit() {

    this.loadLimit = 30;
    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.dateRangeTimeFiltersService.thisCalendarMonth()
    };

    this.projectsRef.$query(this.getProjectsQuery());
    this.infiniteScroll = this.$infiniteScroll(this.projectsRef, this.loadLimit);

    // Deliveries Create Event
    this.projectsRef.$onCreate(this.$scope, (projects) => {

      const filteredProjects = this.filterProjects(
        projects,
        this.filterConfig.range.dateStart,
        this.filterConfig.range.dateEnd
      );

      if (filteredProjects.length) {
        this.infiniteScroll.addItems(_.map(filteredProjects, 'id'));
      }
    });

  }

  $onChanges(changes) {
    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      this.loadProjects();
    }
  }

  // ******************************
  //        Public methods
  // ******************************
  onRangeChanged(range) {
    this.filterConfig.range = range;
    this.loadProjects();
  }

  onDeleteProject(project, event) {
    this.confirmDialogService.confirm('Delete Project', 'Are you sure you want to delete this project?', event)
      .then(() => {
        this.deleteProject(project);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      })
  }

  // ******************************
  //        Private methods
  // ******************************


  private loadProjects() {
    this.projectsRef.$query(this.getProjectsQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Failed to load projects', error)
      })
  }


  private getProjectsQuery() {
    return {
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      branchIds: this.branchIds,
      limit: this.loadLimit
    }
  }


  private deleteProject(project) {
    this.bringozLoaderService.on();
    this.planningRequestsService.deleteProject(project.id)
      .then(() => {
        this.planningAlertsService.deleteProjectSuccess();
        this.loadProjects();
      })
      .catch(() => {
        this.planningAlertsService.deleteProjectError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private filterProjects(projects, from, to) {
    return _.filter(projects, function (project) {
      return project.from >= from && project.to < to;
    });
  }


}


angular
  .module('bringoz.admin.planning')
  .component('planningProjectsTableView', {
    bindings: {
      branchIds: '<?'
    },
    template: require('./planning-projects-table-view.html').default,
    controller: PlanningProjectsTableViewCtrl
  });
